/** under window key */
export const CobrowserKey = "__auvious_cobrowser";
//# sourceMappingURL=model.js.map